import React, { useEffect, useState } from 'react';

function DeleteLead({ LeadData }) {
  const [leadToDelete, setLeadToDelete] = useState({});

  useEffect(() => {
    if (LeadData) {
      setLeadToDelete(LeadData);
    }
  }, [LeadData]);

  return (
    <div className="text-left px-2 pb-0">
      <h6 className="text-danger mb-3">
        The following lead record will be deleted permanently and cannot be recovered:
      </h6>

      <ul className="list-unstyled">
        <li><strong>Client Name:</strong> {leadToDelete.ClientName || 'N/A'}</li>
        <li><strong>Mobile No:</strong> {leadToDelete.MobileNumber || 'N/A'}</li>
        <li><strong>Email ID:</strong> {leadToDelete.EmailId || 'N/A'}</li>
        <li><strong>Description:</strong> {leadToDelete.Description || 'N/A'}</li>

        {leadToDelete.ClientCompanyTypeNames && (
          <li><strong>Product Investments:</strong> {leadToDelete.ClientCompanyTypeNames}</li>
        )}
      </ul>

      {/* Hidden field for debugging or submission (if needed) */}
      <div id="DeleteLeadDetails" hidden>
        {JSON.stringify(leadToDelete)}
      </div>
    </div>
  );
}

export default DeleteLead;
